import React from 'react';

import InfoIconModalPopover from '@repo/editor/src/components/PricingPlan/InfoIconModalPopover';
import CheckIcon from '@repo/ui/components/Icon/CheckIcon';

import { Anchor } from 'components/utilities/pageStyles';
import { buildTypeformUrl } from 'global/urlUtils';

import { ComparisonItem } from './styles';
import { ItemProps } from './types';

const Item: React.FC<ItemProps> = ({
  label,
  check,
  contactSales,
  infoIconModalContent,
}) => {
  return (
    <ComparisonItem>
      {check && <CheckIcon height="8px" />}
      {label && <span>{label}</span>}
      {infoIconModalContent && (
        <InfoIconModalPopover infoModalData={infoIconModalContent} />
      )}
      {contactSales && (
        <Anchor
          href={buildTypeformUrl('fu8R5zSQ')}
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact Sales
        </Anchor>
      )}
    </ComparisonItem>
  );
};

export default Item;
